<template>
  <div class="product-list" @click.stop>
    <div v-if="catList&&catList.length > 0">
      <NavIndex :catList="catList" :onChange="onCateNavChange" />
    </div>
    <div v-if="catList&&catList.length > 0" class="bread">
      <a :href="'/shopHome/?channelId=999'" target="_self">{{ TLang('京东优选','my') }}</a>
      <span>></span>
      <span>{{TLang('商品列表','list')}}</span>
    </div>
    <div v-if="catList&&catList.length > 0">
      <SelectBar
        :catList="catList"
        :brandList="brandList"
        :noStockGrayStatus = "noStockGrayStatus"
        :selectType="'list'"
        :onCateChange="onCateChange"
        :onBrandChange="
          (brandname) => {
            longParams = {
              ...longParams,
              pageNumber: 1,
              brandName: brandname,
            };
            init();
          }
        "
        :chooseAll="chooseAll"
      />
    </div>
    <div class="SearchBar-wrap">
      <SearchBar
        :onSortFieldChange="
          (sortField) => {
            longParams = {
              ...longParams,
              sortType:'',
              sortField,
              pageNumber: 1,
            };
            init();
          }
        "
        :onSortTypeChange="
          (sortType) => {
            longParams = {
              ...longParams,
              sortField: 4,
              sortType,
              pageNumber: 1,
            };
            init();
          }
        "
        :onPriceChange="
          (price) => {
            longParams = {
              ...longParams,
              ...price,
              pageNumber: 1,
            };
            init();
          }
        "
        :onKeyWordChange="
          (wordsName) => {
            longParams = {
              ...longParams,
              wordsName,
              pageNumber: 1,
            };
            init();
          }
        "
        :onStockChange="
          (containsNoStock) => {
            longParams = {
              ...longParams,
              containsNoStock,
              pageNumber: 1,
            };
            init();
          }
        "
        :total="total"
      />
    </div>
    <div class="goods-wrap">
      <ul>
        <li v-for="goods in goodsList" :key="goods.goodsId">
          <Goods
            :goods="goods"
            :onClick="toDetailAndMemory"
            :onClickAdd="onClickAdd.bind(this, goods)"
            :purchaseType="goods.purchaseType"
          />
        </li>
      </ul>
      <Empty v-if="isEmpty" :topre="topre" />
    </div>
    <div v-if="goodsList.length && total > 20" class="Pagination">
      <Pagination
        :current-page.sync="longParams.pageNumber * 1"
        :page-size="20"
        layout="prev, pager, next, total, jumper"
        :total="total"
        background
        @current-change="handleCurrentChange"
      ></Pagination>
    </div>
    <SkuPicker
      :visible="SkuPickerShow"
      :goods="activeGoods"
      :onClose="onCloseSkuModal"
      :onAdd="onClickSkuAdd"
    />
    <Dialog
      title=" "
      :visible.sync="dialogVisible"
      width="420px"
      custom-class="product-dialog"
      center
      top="50vh"
      :lock-scroll="false"
      @open="dialogVisible = true"
    >
      <img :src="require('../../../assets/images/cart_ok.png')" />
      <div class="title">{{TLang('加入购物车成功','my')}}</div>
      <div class="goods-name">
        {{ chooseOfAdd.goodsName }}
      </div>
      <div class="goods-sku-name">
        {{TLang('规格','my') }}：{{ chooseOfAdd.specValue1 || chooseOfAdd.specName }}
      </div>
      <div class="btns">
        <button class="close-btn" @click="toDetail(chooseOfAdd)">
          {{TLang('查看商品详情','my')}}
        </button>
        <button class="buy-btn primary" @click="onClickGoBuy">{{TLang('去结算','my')}}</button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchProductListById, fetchGoodsTags } from "@fetch";
import { getQueryString, unionFlag } from "@utils";
import { dealTagGoods } from '@/utils/special'
import NavIndex from "./../../JDLife/NavIndex";
import SelectBar from "./SelectBar";
import SearchBar from "./SearchBar";
import Goods from "./../../JDLife/GoodsItem";
import { Pagination } from "element-ui";
import { fetchaddCart, fetchSkuBySpuId, getActivityTag } from "@fetch/shopping";
import Loading from "@components/SimpleLoading";
import SkuPicker from "@components/SkuPicker";
import { Dialog } from "element-ui";
import Cookies from "js-cookie";
import Toast from "@components/simpleToast";
import Empty from "./Empty";
import { healthChannelId, noHeadUnion } from "@utils/config";
// import Toast from '@components/simpleToast';
export default {
  name: "JDList",
  components: {
    NavIndex,
    SelectBar,
    SearchBar,
    Goods,
    Pagination,
    SkuPicker,
    Dialog,
    Empty,
  },
  data() {
    return {
      catList: [],
      longParams: {
        lowerPriceLimit: getQueryString("lp"),
        priceCap: getQueryString("hp"),
        sortType: null,
        sortField: getQueryString("sortField") || "1",
        categoryIdList: [getQueryString("categoryId") || null],
        channelId: getQueryString("channelId") || "2",
        pageNumber: 1,
        pageSize: 20,
        goodsType: getQueryString("goodsType") || "0",
        brandName: getQueryString("bn"),
        wordsName: getQueryString("keyword"),
        containsNoStock: getQueryString('stock') == 'false' ? false : true || true,
      },
      brandList: [],
      goodsList: [],
      total: 0,
      activeGoods: {},
      SkuPickerShow: false,
      addressInfo:
        Cookies.get("address") && JSON.parse(Cookies.get("address") || "{}"),
      dialogVisible: false,
      chooseOfAdd: {},
      isEmpty: false,
      healthChannelId: healthChannelId,
      noHeadUnion: noHeadUnion,
      union: unionFlag(),
      noStockGrayStatus: false,
    };
  },
  computed: {
    ...mapGetters("shopCart", ["exts", "healthgoodsFlag"]),
    getGoodTagsParams() {
      const goodsList = [];
      this.goodsList.forEach((good) => {
        if (good.categoryId)
          goodsList.push({
            categoryId: good.categoryId,
            goodsId: good.goodsId,
          });
      });
      return goodsList;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      Loading.show();
      // 综合排序传递值调整
      this.longParams.sortField = this.longParams.sortField === '1' ? '' : this.longParams.sortField;
      fetchProductListById({ ...this.longParams }).then(body => {
        debugger
        Loading.hide();
        if (this.longParams.channelId === "999" && body.categoryDtos) {
          this.catList = body.categoryDtos[999];
          // this.catList = res.indexCategoryDtos;
          // this.catList = res.shopCategories;
        } else {
          this.catList = [];
        }
        // CONSOLE.LOG(this.catList)
        this.brandList = body.brandDtos || [];
        this.noStockGrayStatus = body.noStockGrayStatus;
        this.goodsList =
          (body.categoryGoodsDtos &&
            body.categoryGoodsDtos.categoryGoodsDtoList) ||
          [];
        this.getGoodsTags();
        if (
          !body.categoryGoodsDtos ||
          !body.categoryGoodsDtos.categoryGoodsDtoList ||
          body.categoryGoodsDtos.categoryGoodsDtoList.length === 0
        ) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
        this.total = body.count;
      });
    },
    topre() {
      window.history.go(-1);
    },
    resetLongParams() {
      this.longParams = {
        lowerPriceLimit: getQueryString("lp"),
        priceCap: getQueryString("hp"),
        sortType: null,
        sortField: getQueryString("sortField") || "1",
        categoryIdList: [],
        channelId: getQueryString("channelId") || "2",
        pageNumber: 1,
        pageSize: 20,
        goodsType: getQueryString("goodsType") || "0",
        brandName: null,
        wordsName: getQueryString("keyword"),
      };
    },
    chooseAll() {
      this.resetLongParams();
      this.init();
      this.$router.push({
        path: "/product/JDList",
        query: {
          ...this.$route.query,
          categoryIdList: null,
          bn: null,
          hp: getQueryString("hp"),
          lp: getQueryString("lp"),
          keyword: getQueryString("keyword"),
        },
      });
    },
    onCateChange(item, goodsType = 0) {
      this.longParams = {
        ...this.longParams,
        pageNumber: 1,
        categoryIdList: [item.id],
        goodsType,
        brandName: null,
        // wordsName: null
      };
      this.init();
    },
    onCateNavChange(id) {
      // window.open(`/shopHome/list?categoryId=${id}&channelId=999`)
      window.location.href = `/shopHome/list?categoryId=${id}&channelId=999`;
    },
    // 当前分页
    handleCurrentChange(page) {
      this.longParams = { ...this.longParams, pageNumber: page };
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.init();
    },
    toDetailAndMemory(goods) {
      if (goods.goodsType === 1) {
        window.open(`/birthday/goods/detail/${goods.spuId}?city=${
          this.addressInfo.cityId || 145
        }`,this.isFeishuOrDingding ? '_self' : '_blank')
        // window.location.href = `/birthday/goods/detail/${goods.spuId}?city=${
        //   this.addressInfo.cityId || 145
        // }`;
        return;
      }
      window.open(`/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`,this.isFeishuOrDingding ? '_self' : '_blank')
      // window.location.href = `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`;
    },
    toDetail(goods) {
      window.open(`/shop/product/detail?cid=${goods.goods.categoryId}&gid=${goods.goodsId}`,this.isFeishuOrDingding ? '_self' : '_blank')
      // window.location.href = `/shop/product/detail?cid=${goods.goods.categoryId}&gid=${goods.goodsId}`;
    },
    onClickAdd(goods) {
      fetchSkuBySpuId({
        categoryId: goods.categoryId,
        spuId: goods.mallSpuId,
      }).then((body) => {
        if (body && body.length) {
          // 单规格
          if (body.length === 1) {
            const myChoose = {
              ...body[0],
              num: body[0].buyMin || 1,
            };
            this.onClickSkuAdd(myChoose, { goods });
            return;
          }
          try {
            let checkList = []
            body && body.length > 0 && body.forEach(item => {
              item.tags = []
              if (item.categoryId && item.goodsId) {
                checkList.push({
                  categoryId: item.categoryId,
                  goodsId: item.goodsId,
                })
              }
            })
            checkList && checkList.length > 0 && getActivityTag({
              channel: 2,
              goodsList: checkList,
            }).then((res) => {
              if (res && res.length > 0){
                body && body.length > 0 && body.forEach(item => {
                  item = dealTagGoods(item, res);
                })
                this.activeGoods = goods;
                this.activeGoods.goodsSpecList = body;
                this.SkuPickerShow = true;
              } else {
                this.activeGoods = goods;
                this.activeGoods.goodsSpecList = body;
                this.SkuPickerShow = true;
              }
            })
          } catch (error) {
            this.activeGoods = goods;
            this.activeGoods.goodsSpecList = body;
            this.SkuPickerShow = true;
          }
        }
        if (body.msg) {
          Toast.info(body.msg, 1);
        }
      });
    },
    onCloseSkuModal() {
      this.SkuPickerShow = false;
    },
    onClickSkuAdd(myChoose, g) {
      // console.log(myChoose, g);
      this.chooseOfAdd = { ...myChoose, ...g };
      fetchaddCart({
        categoryId: g.goods.categoryId,
        goodsId: myChoose.goodsId,
        goodsNum: myChoose.num,
        ...this.addressInfo,
      }).then((body) => {
        if (body === "成功") {
          this.dialogVisible = true;
        } else {
          Toast.info(body.msg, 1);
        }
      });
      this.onCloseSkuModal();
    },
    onClickGoBuy() {
      window.open("/shop/shopping/cart",this.isFeishuOrDingding ? '_self' : '_blank')
      // window.location.href = "/shop/shopping/cart";
    },
    // 商品数据拼接tag
    goodsListAddFlag(res) {
      this.goodsList.forEach((good) => {
        const goodTag = res.find(
          (tag) =>
            tag.categoryId == good.categoryId && tag.goodsId == good.goodsId
        ) || {};
        let tags = goodTag && goodTag.tags ? goodTag.tags : [];
        const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
        const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
        const bizStock = goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
        this.$set(good, "tags", tags);
        this.$set(good, "promPrice", promPrice);
        this.$set(good, "salePrice", salePrice);
        this.$set(good, "bizStock", bizStock);
        // 拼接折扣信息
        this.$set(good, "discount", goodTag.discount);
        this.$set(good, "discountPrice", goodTag.discountPrice);
        this.$set(good, "discountTagShow", goodTag.discountTagShow);
        this.$set(good, "mktTagShow", goodTag.mktTagShow);
      });
    },
    // 获取商品tag
    getGoodsTags() {
      if (this.getGoodTagsParams && this.getGoodTagsParams.length > 0) {
        fetchGoodsTags({ goodsList: this.getGoodTagsParams, channel: 2 }).then(
          (res) => {
            if (res && res.length > 0) {
              this.goodsListAddFlag(res);
            }
          }
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.product-list {
  .SearchBar-wrap {
    margin-top: 16px;
  }
  .bread {
    a,
    span {
      line-height: 48px;
      font-size: 12px;
      color: #999;
    }
  }
  .goods-wrap {
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        margin-right: 50px;
        margin-bottom: 10px;
        padding: 30px 0;
        min-height: 282px;
        box-sizing: border-box;
        &:nth-child(5n) {
          margin-right: 0;
        }
        /deep/ .GoodsItem {
          width: 200px;
        }
        /deep/ .imgBox {
          margin: 0;
          width: 200px;
          height: 200px;
        }
        /deep/ .goods-name {
          padding: 0 14px;
        }
        /deep/ .row-price {
          padding: 0 14px;
        }
      }
    }
  }
  .Pagination {
    /deep/ .el-pagination {
      float: right;
      margin-bottom: 20px;
    }
  }
  /deep/ .product-dialog {
    transform: translateY(-50%);
    text-align: center;
    /deep/ .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn {
        font-size: 24px;
        top: 15px;
      }
    }
    img {
      width: 85px;
      height: 55px;
    }
    /deep/ .el-dialog__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        line-height: 24px;
      }
      /deep/ .btns {
        margin-top: 30px;
        button {
          width: 120px;
          height: 40px;
          border-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          line-height: 40px;
          &:hover {
            cursor: pointer;
          }
        }
        /deep/ .close-btn {
          border: 1px solid rgba(229, 229, 229, 1);
          color: #999;
          margin-right: 30px;
          width: auto;
        }
        /deep/ .primary {
          background: linear-gradient(
            315deg,
            rgba(92, 180, 236, 1) 0%,
            rgba(61, 150, 226, 1) 100%
          );
          border-radius: 4px;
          color: #fff;
        }
      }
    }
  }
}
</style>
